<template>
  <div class="container">
    <div class="nav-box"></div>
    <div class="details-wrap">
      <p>
       {{details[count].text}}
      </p>
      <p >
          <img :src="details[count].imgSrc" alt="">
      </p>
    </div>
  </div>
</template>
<script>
export default {
    name:'detail',
    data(){
        return {
          count:this.$route.query.id,
           details:[
            {text:'1929年12月，邓小平等同志在广西百色成功发动和领导的武装起义——百色起义，创建了中国工农红军第七军和右江苏维埃政权，开辟了右江革命根据地。',imgSrc: require('../../assets/qy1.jpg')},
            {text:'1930年2月1日，邓小平等老一辈无产阶级革命家组织和领导了龙州起义，创建中国红军第八军和左江革命根据地，带领崇左各族人民在桂西南大地掀起了轰轰烈烈的红色革命运动。',imgSrc: require('../../assets/qy2.jpg')},
            {text:'1934年11月25日至12月13日，中央红军长征经过广西，历时19天，途经如今的广西桂林市所辖灌阳、全州、兴安、资源、灵川、龙胜6县，克服重重困难，突破湘江封锁线，翻越长征以来的第一座高山———老山界。',imgSrc: require('../../assets/qy3.jpg')},
            {text:'1934年11月25日至12月1日，历时7天的湘江战役在全州、兴安和灌阳三县展开，中央红军以重大代价，从全州、兴安间渡过湘江，突破了国民党军队设置的湘江封锁线，赢得了战略上的胜利。这个生死攸关的重大胜利，为红军后续长征提供了前提和可能。2021年4月25日，习近平总书记来到位于全州县的红军长征湘江战役纪念园，向湘江战役红军烈士敬献花篮并参观红军长征湘江战役纪念馆。',imgSrc: require('../../assets/qy4.jpg')},
            {text:'1927年10月，毛泽东、朱德、陈毅、彭德怀等老一辈无产阶级革命家率领中国工农红军来到井冈山，创建以宁冈县为中心的中国第一个农村革命根据地，开辟了“以农村包围城市、武装夺取政权”的具有中国特色的革命道路。',imgSrc: require('../../assets/qy5.jpg')},
            {text:'韶山，作为伟大领袖毛主席的故乡，是中国红色文化的发源地、是全国革命根据地、爱国主义教育基地和首个红色旅游示范基地，拥有丰富的红色资源、优秀的红色传统，更有着深入骨髓的红色基因。',imgSrc: require('../../assets/qy6.jpg')},
            {text:'1935年1月中共中央政治局在贵州遵义召开了独立自主地解决中国革命问题的一次极其重要的扩大会议——遵义会议。遵义会议结束了王明“左”倾机会主义路线在党中央的统治，确立了以毛泽东为代表的新的中央正确领导，把党的路线转到了马克斯列宁主义的轨道上来。',imgSrc: require('../../assets/qy7.jpg')},
            {text:'延安和陕甘宁边区，曾经是中共中央的所在地，曾经是中国人民解放斗争的总后方。延安以“中国革命的圣地”而闻名。党中央在延安的十三年，是我们党由弱变强、转败为胜的十三年，是毛泽东思想日益成熟、发展的十三年，是延安精神孕育形成、发扬光大的十三年。',imgSrc: require('../../assets/qy8.jpg')},
          ]
        }
    },
    created(){
        
    },
    mounted() {
    this.$emit("childVal", 2);
  }
};
</script>
<style scoped lang="less">
.container {
    background-color: #fff !important;
  .details-wrap {
    width: 790px;
    min-height:1000px;
    margin: 30px auto 0;
    p {
      line-height: 2rem;
      text-align: justify;
      img {
          margin:20px auto;
          display: inline-block;
          object-fit: cover;
      }
    }
  }
  .nav-box {
    height: 74.33px;
    background-color: #1e2430;
  }
}
</style>